export const pageOptions = [20, 30, 50, 100]
